/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-10 15:01:15
 * @LastEditors: caiqin.xie
 * @message: 搜索结果页-搜索列表item
 */
import React, { useState } from "react";
import { IconDown, IconUp } from "@arco-design/web-react/icon";
import styles from "../../index.module.scss";
import { DOMAIN_API, BLOGTYPE, FAQTYPE, NEWSTYPE, AFTERSERVICETYPE, POPULARFORUMSTYPE } from "../../../../../../common";
import classNames from "classnames";

interface IList {
  id: string;
  title: string; // 标题
  briefIntroduction: string; // 简介
  dataType: number; // 数据类型 1-内容 2-门店 3-产品
  contentTypeId: string; // 内容类型id
  seoUrl: string; // 地址栏显示名称
  [key: string]: any;
}
interface IProps {
  ctry: string;
  item: IList;
}
const ResultItem = (props:IProps) => {
  const {ctry, item} = props
  const [isExpand, setIsExpand] = useState(false);

  const renderLink = (contentTypeId: string,  seoUrl: string) => {
    let linkPath: string = ''
    switch(contentTypeId) {
      case BLOGTYPE:
        linkPath = `/${ctry}/blog/${seoUrl}`
        break
      case FAQTYPE:
        linkPath = `/${ctry}/support/faq`
        break
      case NEWSTYPE:
        linkPath = `/${ctry}/newsroom/${seoUrl}`
        break
      case POPULARFORUMSTYPE:
        linkPath = `/${ctry}/support/popular-forums/${seoUrl}`
        break
      case AFTERSERVICETYPE:
        linkPath = `/${ctry}/support/after-service`
        break
      default:
        linkPath = `/${ctry}/support/search-content/${seoUrl}?contentTypeId=${contentTypeId}`
    }
    return linkPath
  }

  return (
    <div className={styles['result-list']}>
      <div className={styles['result-list-item']} key={item.id}>
          <h3 className={styles['list-item-title']}>{item.title}</h3>
          <div className={styles['list-item-content-wrap']}>
            <p className={classNames(styles['list-item-content'], {
              [styles['full-height']]: isExpand
            })}>{item.briefIntroduction}</p>
            
            <span onClick={() => setIsExpand(!isExpand)}>
              { isExpand ? <IconUp className={styles['list-item-arrow']} /> : <IconDown className={styles['list-item-arrow']} />}
            </span>
          </div>
          
          {/* dataType 1-内容 2-门店 3-产品 */}
          {item.dataType === 1 && (
            <a href={renderLink(item.contentTypeId, item.seoUrl)}>
              <span className={styles['list-item-link']}>
                {DOMAIN_API}{renderLink(item.contentTypeId, item.seoUrl)}
              </span>
            </a>
          )}
          {item.dataType === 2 && (
            <a href={`/${ctry}/shop`}>
              <span className={styles['list-item-link']}>{DOMAIN_API}/{ctry}/shop</span>
            </a>
          )}
          {item.dataType === 3 && (
            <a href={`/${ctry}/support/product-support/${item.title}`}>
              <span className={styles['list-item-link']}>{DOMAIN_API}/{ctry}/support/product-support/{item.title}</span>
            </a>
          )}
          
        </div>
    </div>
  )
}
export default ResultItem